import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_timing'

export default function DreamTimingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'When do you usually remember your dreams?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamTiming.heading')}
      buttons={[
        {
          text: `🌅 ${t('pages.onboarding.dreamTiming.options.immediately')}`,
          value: 'Right when I wake up',
          subtext: t('pages.onboarding.dreamTiming.subtexts.immediately'),
        },
        {
          text: `☕ ${t('pages.onboarding.dreamTiming.options.fewMinutes')}`,
          value: 'A few minutes after waking',
          subtext: t('pages.onboarding.dreamTiming.subtexts.fewMinutes'),
        },
        {
          text: `🚿 ${t('pages.onboarding.dreamTiming.options.duringRoutine')}`,
          value: 'During my morning routine',
          subtext: t('pages.onboarding.dreamTiming.subtexts.duringRoutine'),
        },
        {
          text: `💭 ${t('pages.onboarding.dreamTiming.options.randomFlashes')}`,
          value: 'Random flashes during the day',
          subtext: t('pages.onboarding.dreamTiming.subtexts.randomFlashes'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
